export var SUCCESS_SUFFIX = '_SUCCESS';
export var ERROR_SUFFIX = '_ERROR';
export var ABORT_SUFFIX = '_ABORT';
export var CLEAR_REQUESTS_CACHE = 'CLEAR_REQUESTS_CACHE';
export var RESET_REQUESTS = 'RESET_REQUESTS';
export var ABORT_REQUESTS = 'ABORT_REQUESTS';